import React from 'react';

import { useGroupState, useGroupActions } from './GroupContext';
import { useCapabilities } from '../../Shared/capabilities';
import { addAdmin, removeAdmin } from './restApi';
import Button from '../../Shared/UI/Button/components/Button';

import styles from './PermissionsSection.module.scss';

const GroupAdminsSection = () => {
  const state = useGroupState();
  const { onResponse, onError } = useGroupActions();
  const capabilities = useCapabilities();
  const admins = state?.admins || [];
  const eligibleForAdmin = state?.eligibleForAdmin || [];
  const ownerId = state?.ownerId || null;

  const groupId = state?.group?.id;
  const authenticityToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");

  const handleAddAdmin = (userId) => {
    addAdmin({
      id: groupId,
      onResponse,
      onError,
      body: { userId, authenticityToken },
    });
  };

  const handleRemoveAdmin = (userId) => {
    removeAdmin({
      id: groupId,
      onResponse,
      onError,
      body: { userId, authenticityToken },
    });
  };

  return (
    <div className={styles.adminsSection}>
      <h3 className={styles.adminsSectionTitle}>Group Admins</h3>
      <p className={styles.adminsSectionDescription}>
        Admins can manage group settings and permissions. Only the group owner can add or remove admins.
      </p>

      <div className={styles.adminsSubsection}>
        <span className={styles.subsectionLabel}>Current admins:</span>
        {admins.length > 0 ? (
          <ul className={styles.userList}>
            {admins.map((user) => (
              <li key={user.id} className={styles.userRow}>
                <img
                  src={user.profilePicturePath}
                  alt={user.name}
                  className={styles.avatar}
                />
                <span className={styles.userName}>
                  {user.name}
                  {user.id === ownerId && <span className={styles.ownerBadge}>Owner</span>}
                </span>
                {capabilities.canManageAdmins && user.id !== ownerId && (
                  <Button variant="secondary" onClick={() => handleRemoveAdmin(user.id)}>
                    Remove
                  </Button>
                )}
              </li>
            ))}
          </ul>
        ) : (
          <p className={styles.coveredNote}>No admins assigned.</p>
        )}
      </div>

      {eligibleForAdmin.length > 0 && capabilities.canManageAdmins && (
        <div className={styles.adminsSubsection}>
          <span className={styles.subsectionLabel}>Add admin from members:</span>
          <ul className={styles.userList}>
            {eligibleForAdmin.map((user) => (
              <li key={user.id} className={styles.userRow}>
                <img
                  src={user.profilePicturePath}
                  alt={user.name}
                  className={styles.avatar}
                />
                <span className={styles.userName}>{user.name}</span>
                <Button variant="secondary" onClick={() => handleAddAdmin(user.id)}>
                  Add
                </Button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default GroupAdminsSection;
